var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBsLogoSnatureWh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 21,
    viewBox: "0 0 108 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_617_1615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.30132 7.24654C4.88247 6.51885 4.37689 6.09788 3.47997 6.09788C2.53862 6.09788 1.72632 6.77058 1.72632 7.73731C1.72632 8.64904 2.66343 9.07 3.38055 9.39365L4.08285 9.7025C5.45785 10.3054 6.62132 10.995 6.62132 12.6788C6.62132 14.5256 5.1342 15.9429 3.29382 15.9429C1.59939 15.9429 0.336508 14.8513 -0.00195312 13.2098L1.14882 12.8883C1.30535 13.9692 2.13035 14.8535 3.26632 14.8535C4.40228 14.8535 5.44093 13.9862 5.44093 12.7931C5.44093 11.6 4.47209 11.1388 3.49266 10.6862L2.84535 10.4048C1.60997 9.84635 0.545931 9.21596 0.545931 7.69712C0.550162 6.05346 1.93574 5 3.50535 5C4.68574 5 5.67997 5.60712 6.24478 6.64577L5.30132 7.24654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.408 14.1848C15.408 14.8131 14.9045 15.3356 14.2763 15.3356C13.648 15.3356 13.1445 14.8131 13.1445 14.1848C13.1445 13.5565 13.6522 13.0742 14.2763 13.0742C14.9003 13.0742 15.408 13.5819 15.408 14.1848Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5577 15.822H59.3794V6.33454H56.8262V5.24512H63.1385V6.33666H60.5598V15.822H60.5577Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5749 11.5405C72.5749 12.3274 72.5453 13.2243 73.0382 13.897C73.5015 14.5443 74.337 14.9082 75.1049 14.9082C75.8728 14.9082 76.6936 14.557 77.1822 13.9668C77.7428 13.2942 77.6349 12.3655 77.6349 11.5384V5.24512H78.8153V11.8642C78.8153 13.0128 78.7286 13.9245 77.8888 14.7982C77.159 15.5809 76.1753 15.9997 75.107 15.9997C74.1149 15.9997 73.1503 15.6232 72.4353 14.9251C71.5066 14.0409 71.3945 13.072 71.3945 11.862V5.24512H72.5749V11.5405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1644 15.822H87.9883V5.24512H89.5156C91.521 5.24512 93.3867 5.77819 93.3867 8.16012C93.3867 9.78896 92.3629 10.9418 90.7362 11.0815L93.8881 15.5217C93.9769 15.6486 93.8881 15.822 93.7337 15.822H92.6612L89.4585 11.1767H89.1644V15.822ZM89.1644 10.1401H89.5304C90.8631 10.1401 92.2064 9.88839 92.2064 8.24473C92.2064 6.50589 90.9308 6.33454 89.5156 6.33454H89.1644V10.1401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.385 5.24512H107.87V6.33666H103.565V9.48223H107.17V10.5738H103.565V14.7263H107.87V15.8242H102.385V5.24512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8879 15.5469V15.0138V14.9567V5.20266H31.7012V13.4336L23.9441 5.30631C23.9441 5.30631 23.7706 5.11381 23.5844 5.18785C23.3877 5.25977 23.4089 5.51785 23.4089 5.51785L23.4131 6.05092V15.8303H24.5956V7.64169L31.8937 15.2761L32.3548 15.7584C32.3548 15.7584 32.5283 15.9488 32.7102 15.8811C32.9006 15.8092 32.8879 15.568 32.8858 15.5469H32.8879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6356 12.7991L42.3516 15.822H41.0527L45.6558 5.36778C45.6558 5.36778 45.7489 5.11816 45.9668 5.11816C46.1677 5.11816 46.2608 5.36778 46.2608 5.36778L50.7539 15.822H49.4402L48.1816 12.7991H43.6356ZM45.9372 7.43451L44.1158 11.6991H47.7162L45.935 7.43451H45.9372Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_617_1615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107.87,
    height: 11,
    fill: "white",
    transform: "translate(0 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsLogoSnatureWh);
export default __webpack_public_path__ + "static/media/BS_logo_snature_wh.82c140a673a9590df7ac3d0424be2ac3.svg";
export { ForwardRef as ReactComponent };